import Currency, { CurrencyCode } from "./Currency";


type CurrenciesProps = {
    cp: number;
    sp: number;
    ep: number;
    gp: number;
    pp: number;
    onChange?: (currency: CurrencyCode, amount: number) => void;
    onBlur?: () => void;
    outline?: boolean;
};

function Currencies({
    cp,
    sp,
    ep,
    gp,
    pp,
    onChange,
    onBlur,
    outline = false,
}: CurrenciesProps) {
    return (
        <div className="currencies row row-cols-2 row-cols-sm-5 g-2 mb-3">
            <div className="col">
                <Currency
                    currency='cp'
                    value={cp}
                    onChange={(amount) => onChange?.('cp', amount)}
                    onBlur={() => onBlur?.()}
                    outline={outline}
                />
            </div>
            <div className="col">
                <Currency
                    currency='sp'
                    value={sp}
                    onChange={(amount) => onChange?.('sp', amount)}
                    onBlur={() => onBlur?.()}
                    outline={outline}
                />
            </div>
            <div className="col">
                <Currency
                    currency='ep'
                    value={ep}
                    onChange={(amount) => onChange?.('ep', amount)}
                    onBlur={() => onBlur?.()}
                    outline={outline}
                />
            </div>
            <div className="col">
                <Currency
                    currency='gp'
                    value={gp}
                    onChange={(amount) => onChange?.('gp', amount)}
                    onBlur={() => onBlur?.()}
                    outline={outline}
                />
            </div>
            <div className="col">
                <Currency
                    currency='pp'
                    value={pp}
                    onChange={(amount) => onChange?.('pp', amount)}
                    onBlur={() => onBlur?.()}
                    outline={outline}
                />
            </div>
        </div>
    );
}

export default Currencies;
